import { CardPriceCurrenciesEnum } from "modules/cards/model/card-price";

export const LOCALE = "en-US";
const DEFAULT_CURRENCY = CardPriceCurrenciesEnum.EUR;

export function formatCurrency(
  value: number,
  currency: string = DEFAULT_CURRENCY
): string {
  if (!/^[A-Z]{3}$/.test(currency)) {
    return value.toLocaleString(LOCALE);
  }
  return value.toLocaleString(LOCALE, { style: "currency", currency });
}

export function formatNumber(value: number): string {
  return value.toLocaleString(LOCALE);
}

export function priceCurrency(
  cards: Array<{ price?: { currency?: CardPriceCurrenciesEnum } }>,
  fallback: CardPriceCurrenciesEnum = DEFAULT_CURRENCY
): CardPriceCurrenciesEnum {
  return (
    cards.find((card) => card.price?.currency)?.price?.currency ?? fallback
  );
}

export function currencySymbol(currency: string): string {
  return currency === "USD" ? "$" : currency === "EUR" ? "€" : currency;
}
